<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Name</mat-label>
        <input [(ngModel)]="newbookingData.customerName" matInput />
        
      </mat-form-field>
    </div>
    <!-- <div>
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Phone</mat-label>
          <input [(ngModel)]="newbookingData.customerPh" matInput  type="tel" smNumericOnly
          maxlength="10"/>
          
        </mat-form-field>
      </div> -->
    <div class="row g-2 justify-content-between phone-field">
      <mat-form-field appearance="outline" class="col-2 country_form">
        <mat-label>Country</mat-label>
        <mat-select
          [(ngModel)]="selectedCountryCode"
          required
          (selectionChange)="onCountrySelected($event)"
        >
          <mat-select-trigger>
            {{ "(" + selectedCountryCode.dial_code + ")" }}
          </mat-select-trigger>
          <div>
            <input
              style="
                width: 80%;
                height: 25px;
                padding: 10px;
                border: 1px solid lightgray;
                margin: 10px;
                border-radius: 5px;
              "
              [(ngModel)]="searchString"
              matInput
              placeholder="Enter country name"
              (keyup)="onKey()"
            />
          </div>
  
          <mat-option *ngFor="let country of countryList" [value]="country">
            {{ country.flag }} {{ country.name }}
            {{ "(" + country.dial_code + ")" }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="mobile_form col-10" appearance="outline">
        <mat-label>Phone</mat-label>
        <input
          [(ngModel)]="newbookingData.customerPh"
          matInput
          type="tel"
          smNumericOnly
          maxlength="10"
        />
        <mat-hint
          style="color: red; font-size: 13px"
          align="end"
          *ngIf="
            newbookingData.customerPh &&
            newbookingData.customerPh != '' &&
            newbookingData.customerPh.length < 10
          "
          >Please enter a valid phone number in the range of 3-17.</mat-hint
        >
      </mat-form-field>
    </div>
    <!-- <div
      class="chip_cont"
      style="border-bottom: 1px solid lightgray; margin-top: 15px"
    >
      <mat-chip-list aria-label="Fish selection" class="mb-3">
        <mat-chip
          style="height: auto"
          [ngClass]="{ selectedPurple: selectedBookingType == 1 }"
          (click)="changeChip(1)"
          >Today
        </mat-chip>
      </mat-chip-list>
  
      <mat-chip-list aria-label="Fish selection" class="mb-3">
        <mat-chip
          style="height: auto"
          [ngClass]="{ selectedPurple: selectedBookingType == 4 }"
          (click)="changeChip(4)"
          >Tomorrow
        </mat-chip>
      </mat-chip-list>
      <mat-chip-list aria-label="Fish selection" class="mb-3">
        <mat-chip
          style="height: auto"
          [ngClass]="{ selectedPurple: selectedBookingType == 5 }"
          (click)="onSelectDate()"
          >{{ selectedDate ? (selectedDate | date : "longDate") : "Select Date" }}
        </mat-chip>
      </mat-chip-list>
    </div> -->
    <!-- <div class="chip_cont" style="border-bottom: 1px solid lightgray;    margin-top: 15px;">
          <mat-chip-list aria-label="Fish selection" class="mb-3">
            <mat-chip
              style="height: auto"
        [ngClass]="{ selectedPurple: selectedBookingType == 1 }"
        (click)="changeChip(1)"
              >New Booking
            </mat-chip>
          </mat-chip-list>
        
          <mat-chip-list aria-label="Fish selection" class="mb-3">
            <mat-chip
              style="height: auto"
              [ngClass]="{ selectedPurple: selectedBookingType == 4 }"
        (click)="changeChip(4)"
              >Job done
            </mat-chip>
          </mat-chip-list>
        </div> -->
    <p style="margin: 20px 0 0px">
      {{ parentData.data.serviceType == "1" ? "Shop services" : "Home services" }}
    </p>
    <div class="chip_cont" style="padding: 20px 0px">
      <mat-chip-list class="example-chip" *ngIf="serviceList.length > 0">
        <div *ngFor="let item of serviceList">
          <mat-chip
            *ngIf="item.toShow"
            style="height: auto"
            (click)="selectServices(item)"
            >{{ item.serviceName }}
          </mat-chip>
        </div>
     

      </mat-chip-list>
      <p *ngIf="serviceList.length == 0">No service added</p>
    </div>
    <h3 *ngIf="selectedJobs.length > 0">Job completed</h3>
    <div class="" *ngIf="selectedJobs.length > 0">
      <!-- <mat-chip-list aria-label="Fish selection" class="mb-3">
            <mat-chip
              style="height: auto"
              class="selected"
        *ngFor="let item of selectedJobs"
              >{{item.serviceName}}
              <mat-icon matChipRemove (click)="removeSelectedJobs(item)" style="color: red;
              opacity: 1;">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list> -->
      <div *ngFor="let item of selectedJobs; let i = index;">
        <div
          
          style="
            display: inline-block;
            width: fit-content;
            background: #ffc107;
            padding: 8px 20px;
            border-radius: 34px;
            margin-bottom: 20px;
          "
        >
          <p style="margin: 0px; font-weight: 500; font-size: 16px">
            {{ item.serviceName }}
          </p>
        </div>
        <mat-icon style="    font-size: 20px;
        font-weight: 900;
        color: #000;
        position: relative;
        top: 4px;
        margin-left: 10px;">close</mat-icon>
        <div style="display: inline-block;">
          <span style="    margin-left: 10px;
          border: 1px solid #a2a2a2;
          padding: 10px;
          border-radius: 10px;">
            <button
            (click)="decreaseServiceCount(item,i)"
            style="background: none;
            border: 1px solid #a2a2a2;
            border-radius: 25px;
            width: 25px;
            height: 25px;">
            <mat-icon class="material-icons-outlined" style="    font-size: 16px;
            position: relative;
            top: 2px;
            left: -3px;
            color: #666666;
            height: auto;
            width: auto;">remove</mat-icon>
            </button>
            <span style="    margin: 0 15px;"> {{item.selectedCount}} </span>
            <button 
            (click)="increaseServiceCount(item,i)"
            style="background: none;
            border: 1px solid #a2a2a2;
            border-radius: 25px;
            width: 25px;
            height: 25px;">
            <mat-icon style="    font-size: 16px;
            position: relative;
            top: 2px;
            left: -3px;
            color: #666666;
            height: auto;
            width: auto;" class="material-icons-outlined">add</mat-icon>
            </button>
          </span>
          <!-- <span
          (click)="removeSelectedJobs(item)"
          style="text-decoration: underline;
          margin-left: 20px;
          display: inline-block;
          cursor: pointer;">
            Remove
          </span> -->
          <span style="
          margin-left: 20px;">
            by {{item.employees_record | arrayToStr}}
          </span>
        </div>
      </div>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Cost</mat-label>
        <input
          [(ngModel)]="newbookingData.price"
          matInput
          smDecimalOnly type="number"
          [disabled]="true"
        />
        
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Notes</mat-label>
        <textarea [(ngModel)]="newbookingData.note" matInput></textarea>
        <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
      </mat-form-field>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <!-- <button
      mat-button
      mat-dialog-close
      *ngIf="selectedBookingType == 1 || selectedBookingType == 5"
    >
      Cancel
    </button> -->
    <!-- <button
      *ngIf="selectedBookingType == 1 || selectedBookingType == 5"
      mat-flat-button
      color="accent"
      (click)="onPost()"
      [disabled]="selectedJobs.length == 0 || formChecker()"
    >
      Create new booking
    </button> -->
  
    <button
      mat-button

      style="border: 1px solid #b48700"
      [disabled]="selectedJobs.length == 0 || formChecker()"
      (click)="allDoneAndRelease()"
    >
      All done and release
    </button>
    <button
      mat-button

      style="border: 1px solid #b48700"
      [disabled]="selectedJobs.length == 0 || formChecker()"
      (click)="partiallyDone()"
    >
      Partially done and release
    </button>
    <button

      mat-flat-button
      color="accent"
      (click)="allDone()"
      [disabled]="selectedJobs.length == 0 || formChecker()"
    >
      All done and produce bill
    </button>
  </mat-dialog-actions>
  